/* Floating product video — see snippets/wb-video-bubble.liquid. */
(function () {
  var box = document.querySelector('[data-wb-vb]');
  if (!box) return;

  var KEY = 'wb-video-bubble-closed';
  try {
    if (window.sessionStorage.getItem(KEY)) return;
  } catch (e) {}

  var video = box.querySelector('[data-wb-vb-video]');
  var openBtn = box.querySelector('[data-wb-vb-open]');
  var pauseBtn = box.querySelector('[data-wb-vb-pause]');
  var soundBtn = box.querySelector('[data-wb-vb-sound]');
  var shrinkBtn = box.querySelector('[data-wb-vb-shrink]');
  var closeBtn = box.querySelector('[data-wb-vb-close]');

  function play() {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function sync() {
    box.classList.toggle('is-paused', video.paused);
    box.classList.toggle('is-muted', video.muted);
    pauseBtn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    soundBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
  }

  function setSource(src) {
    if (!src || video.getAttribute('src') === src) return;
    var t = video.currentTime || 0;
    video.src = src;
    video.addEventListener('loadedmetadata', function once() {
      video.removeEventListener('loadedmetadata', once);
      try { video.currentTime = t; } catch (e) {}
    });
  }

  function show() {
    // Muted autoplay is allowed everywhere; the attribute covers browsers
    // that ignore a play() call made before the file has started loading.
    video.autoplay = true;
    setSource(box.dataset.src);
    box.hidden = false;
    // Read layout once so the fade-in transition runs, without waiting on an
    // animation frame (which never fires in a background tab).
    void box.offsetWidth;
    box.classList.add('is-in');
    // The silent loop is the preview, for every visitor.
    play();
    sync();
  }

  function open() {
    box.classList.add('is-open');
    setSource(box.dataset.srcLarge);
    video.autoplay = false;
    video.muted = false;
    video.loop = false;
    play();
    sync();
    pauseBtn.focus({ preventScroll: true });
  }

  function shrink() {
    box.classList.remove('is-open');
    video.muted = true;
    video.loop = true;
    play();
    sync();
    openBtn.focus({ preventScroll: true });
  }

  function close() {
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {}
    video.pause();
    box.classList.remove('is-in');
    setTimeout(function () {
      box.hidden = true;
      video.removeAttribute('src');
      video.load();
    }, 320);
  }

  openBtn.addEventListener('click', open);
  shrinkBtn.addEventListener('click', shrink);
  closeBtn.addEventListener('click', close);
  pauseBtn.addEventListener('click', function () {
    if (video.paused) play();
    else video.pause();
    sync();
  });
  soundBtn.addEventListener('click', function () {
    video.muted = !video.muted;
    sync();
  });
  video.addEventListener('click', function () {
    if (!box.classList.contains('is-open')) return;
    if (video.paused) play();
    else video.pause();
    sync();
  });
  video.addEventListener('canplay', function () {
    if (!box.hidden && video.paused && !box.classList.contains('is-open')) play();
  });
  video.addEventListener('play', sync);
  video.addEventListener('pause', sync);
  // After one full play with sound, settle back to the silent preview.
  video.addEventListener('ended', shrink);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && box.classList.contains('is-open')) shrink();
  });

  // Save data and battery: pause the preview when the tab is hidden.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) video.pause();
    else if (!box.hidden && !box.classList.contains('is-open')) play();
  });

  // Step aside while the footer is on screen, like the WhatsApp button.
  var footer = document.querySelector('.wb-ft, footer');
  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        var tucked = entries[0].isIntersecting && !box.classList.contains('is-open');
        box.classList.toggle('is-tucked', tucked);
      },
      { rootMargin: '0px 0px -40% 0px', threshold: 0 }
    ).observe(footer);
  }

  // Only once the page has finished loading, so the video never competes
  // with the main product photo.
  function schedule() {
    setTimeout(show, 1500);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
